import { makeObservable, observable } from 'mobx';
import { keys } from '../translationsKeys';
import { ACCOUNT_RECOVERY_URL } from '../utils/constants';
import { Constraint, constraints } from '../utils/validators';
import { FormField } from './formField';
import { RootStore } from './root';

export abstract class EnterPasswordStore {
  protected readonly rootStore: RootStore;
  public passwordField: FormField;
  abstract submit(): void;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    const minRule: Constraint = [
      constraints.minimum(6),
      rootStore.i18n.t(keys['validation.password.min'], { number: 6 }),
    ];
    const maxRule: Constraint = [
      constraints.maximum(100),
      rootStore.i18n.t('validation.password.max'),
    ];
    this.passwordField = new FormField('', [minRule, maxRule]);
    makeObservable(this, {
      passwordField: observable,
    });
  }

  public hasError(): boolean {
    return !!(this.passwordField.errorInfo || this.passwordField.serverError);
  }
  isSubmittable(): boolean {
    return this.passwordField.isValid;
  }
}
